<template>
  <div>
      <AlertSystemBar v-if="acesso.instituicao"/>
      <SysCoreNavigationBar />
      <v-main>
        <GovernanceWarningBanner />
        <v-container fluid>
            <!-- <SysCoreBreadcrumbs v-if="menu.length > 0"/> -->
            <router-view></router-view>
        </v-container>
      </v-main>

      <div class="text-center">
        <v-bottom-sheet v-model="sheet" hide-overlay inset>
          <v-card tile>
            <v-progress-linear
              :value="0"
              class="my-0"
              height="5"
              color="red"
            ></v-progress-linear>
          <!-- <v-sheet> -->
            <v-card flat v-if="hasErrors">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-btn text color="info" outlined @click="showOpenTicket = true" v-if="acesso.instituicao && acesso.instituicao.educational_group_id != 16">
                Abrir um chamado
                <v-icon right>mdi-text-box-plus</v-icon>
              </v-btn>
                <v-btn text outlined color="red" @click="sheet = !sheet" class="ml-2">
                  Fechar mensagem
                  <v-icon color="red" right>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
            
  
            <div class="py-3">
              <v-alert dense class="red--text" v-for="(item, i) in errorsHttp" :key="i">
                <template v-slot:prepend>
                  <v-icon class="red--text text--lighten-1">mdi-alert-circle</v-icon>
                </template>
                <div class="text-center" v-if="item.status == 500">
                  <p class="text-h5 mt-2 red--text">Ocorreu um erro inesperado!</p>
                </div>

                <!-- <v-btn
                  color="info"
                  outlined
                  @click.prevent="capturaTela"
                >
                  Capturar imagem
                  <v-icon right>mdi-image-size-select-actual</v-icon>
                </v-btn> -->

              <v-row align="center" no-gutters class="ml-2">
                <v-col class="grow">
                  <p class="ma-0" v-if="hasErrors"><strong>Erro:</strong> {{ item.status }}</p>
                  <p class="ma-0" v-if="hasErrors"><strong>Requisição:</strong> {{ item.url }}</p>
                  <p class="ma-0 red--text text--lighten-2"><strong>Mensagem:</strong> {{ item.message }}</p>
                </v-col>
              </v-row>
              
              </v-alert>
            </div>
          </v-card>
          <!-- </v-sheet> -->
        </v-bottom-sheet>
      </div>

      <OpenTicket 
    :show="showOpenTicket"
    @update:show="(value) => showOpenTicket = value"
/>

    <ChatBot v-if="user.is_internal || ([2171, 1251, 1928, 336, 337, 335, 853].includes(user.id) && isAnima())" />
    <OccupancyBlockOverlay />
    <MenuAccessBlockWatcher />
    <sys-term-profile-blocking-modal
      :show.sync="showProfileBlockingModal"
      :teacherId="teacherId"
      :token="token"
      :initial-terms="pendingBlockingTerms"
      @unblocked="onProfileUnblocked"
    />
    <SysCoreFooter />
  </div>
</template>

<script>

  import { mapActions, mapState } from 'vuex'
  import html2canvas from 'html2canvas';
  import OpenTicket from '../../../modules/management/ticket/pages/ticket/OpenTicket'
  import ChatBot from '../../../domains/communication/bot/components/ChatBot.vue'
  import AlertSystemBar from '../../../domains/communication/alert/components/AlertSystemBar.vue';
  import OccupancyBlockOverlay from '../../../modules/governance/components/OccupancyBlockOverlay.vue'
  import GovernanceWarningBanner from '../../../modules/governance/components/GovernanceWarningBanner.vue'
  import MenuAccessBlockWatcher from '../../../modules/menuAccessBlock/components/MenuAccessBlockWatcher.vue'


  export default {
    name: 'SysCoreMain',
    data: () => ({
      showOpenTicket: false,
      env_sysclass: process.env.VUE_APP_ENV,
      showProfileBlockingModal: false,
      pendingBlockingTerms: null,
      checkingProfileBlockingTerms: false
    }),
    computed: {
      ...mapState('auth', ['user', 'errorsHttp', 'acesso', 'token']),
      teacherId() {
        return this.user?.id || 0
      },
      isTeacherMode() {
        return this.user?.mode === 'teacher'
      },
      isStaging() {
          return !this.env_sysclass || !this.env_sysclass.toString().includes('production');
      },
      sheet: {
          get() {
            return this.errorsHttp.length ? true : false
          },
          set() {
            return this.$store.dispatch('auth/ActionSetErrorsHttp', {})
          }
      },
      hasErrors: {

        get() {

          if(Object.keys(this.errorsHttp).length == 0) return false;

          if(this.errorsHttp.find((item) => item.status == 500) == undefined) return false;
          
          return true;
        }
      }
    },
    components: {
      OpenTicket,
      ChatBot,
      AlertSystemBar,
      OccupancyBlockOverlay,
      GovernanceWarningBanner,
      MenuAccessBlockWatcher,
    },
    mounted() {
      this.checkProfileBlockingTerms()
    },
    watch: {
      user: {
        deep: true,
        handler() {
          this.checkProfileBlockingTerms()
        }
      }
    },
    methods: {
      ...mapActions('term', ['ActionGetPendingBlockingTerms']),
      async checkProfileBlockingTerms() {
        if (this.checkingProfileBlockingTerms) return

        if (!this.isTeacherMode || !this.teacherId) {
          this.showProfileBlockingModal = false
          this.pendingBlockingTerms = null
          return
        }

        this.checkingProfileBlockingTerms = true

        try {
          const response = await this.ActionGetPendingBlockingTerms({
            teacherId: this.teacherId,
            token: this.token || localStorage.getItem('token')
          })
          const data = response.data || response

          if (data.has_blocking_terms && data.terms && data.terms.length > 0) {
            this.pendingBlockingTerms = data.terms
            this.showProfileBlockingModal = true
          } else {
            this.showProfileBlockingModal = false
            this.pendingBlockingTerms = null
          }
        } catch {
          this.showProfileBlockingModal = false
          this.pendingBlockingTerms = null
        } finally {
          this.checkingProfileBlockingTerms = false
        }
      },
      onProfileUnblocked() {
        this.showProfileBlockingModal = false
        this.pendingBlockingTerms = null
      },

      capturaTela() {
        //var element = document.getElementById('app');
        html2canvas(document.body).then(canvas => {

          // Crie um elemento de imagem para exibir o print
          var screenshotImage = new Image();
          screenshotImage.src = canvas.toDataURL('image/png');

          // Crie uma janela pop-up para exibir o print
          var popupWindow = window.open();
          popupWindow.document.write('<html><head><title>Screenshot</title></head><body></body></html>');
          popupWindow.document.body.appendChild(screenshotImage);

        })

      }
    }
  }
</script>
